/* Mr Mattress Revive product page. No libraries.
   1. fade in on scroll   2. desktop picture thumbs   3. "Save R..." chip from the live prices on screen
   4. final Add to cart that presses the real one   5. click to load video   6. smooth scroll to the buy box.
   If this file never loads, nothing is hidden and the buy box still works, because it is the theme's own. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  root.classList.add('revive-page');

  /* 1. reveal on scroll. Anything already in view is marked in before the hidden state is switched on, so nothing flashes. */
  var rv = [].slice.call(d.querySelectorAll('.revive-rv'));
  if (rv.length) {
    if (!hasIO || reduce) {
      rv.forEach(function (e) { e.classList.add('is-in'); });
    } else {
      var vh = window.innerHeight || 800;
      rv.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < vh * 0.92 && r.bottom > 0) e.classList.add('is-in'); });
      root.classList.add('revive-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      rv.forEach(function (e) { if (!e.classList.contains('is-in')) io.observe(e); });
    }
  }

  /* 2. gallery: swipe on phones (dots), thumbs on desktop */
  var gal = d.querySelector('[data-revive-gallery]');
  if (gal) {
    var track = gal.querySelector('[data-revive-track]');
    var dots = [].slice.call(gal.querySelectorAll('.revive-dot')), thumbs = [].slice.call(gal.querySelectorAll('.revive-thumb'));
    function mark(i) { dots.forEach(function (x, n) { x.classList.toggle('is-on', n === i); }); thumbs.forEach(function (x, n) { x.classList.toggle('is-on', n === i); });
      var th = thumbs[i]; if (th && th.parentNode && th.parentNode.scrollWidth > th.parentNode.clientWidth) th.parentNode.scrollTo({ left: th.offsetLeft - (th.parentNode.clientWidth - th.clientWidth) / 2, behavior: 'auto' }); }
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); mark(i); }
    track.addEventListener('scroll', function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
    dots.forEach(function (x, n) { x.addEventListener('click', function () { go(n); }); });
    thumbs.forEach(function (x, n) { x.addEventListener('click', function () { go(n); }); });
  }
  /* sticky bar housekeeping: hide it while one of the page's own buttons is on screen (no double buttons),
     and on phones show the sitewide WhatsApp bubble only while the sticky bar is up (the buy box has its own WhatsApp button) */
  var stickyBar = d.querySelector('.revive-sticky__bar');
  var hideLive = {}, hideN = 0, barOn = false;
  function stickyState() {
    var off = Object.keys(hideLive).some(function (k) { return hideLive[k]; });
    root.classList.toggle('revive-sticky-off', off);
    var stuck = stickyBar && stickyBar.getAttribute('data-stuck') === 'true';
    root.classList.toggle('revive-sticky-on', barOn && !off);
    root.classList.toggle('revive-bar-on', barOn);
  }
  if (stickyBar) {
    if ('MutationObserver' in window) new MutationObserver(stickyState).observe(stickyBar, { attributes: true, attributeFilter: ['data-stuck'] });
    if (hasIO) {
      var hio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { hideLive[en.target.__reviveid] = en.isIntersecting; });
        stickyState();
      }, { threshold: 0.5 });
      [].forEach.call(d.querySelectorAll('[data-revive-hide-sticky]'), function (el) { el.__reviveid = hideN++; hideLive[el.__reviveid] = false; hio.observe(el); });
    }
    var vpick = d.querySelector('.revive-blocks variant-picker');
    var deskMq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: false };
    var vpickOn = false, buyPast = false;
    function barCalc() { barOn = deskMq.matches ? buyPast : vpickOn; stickyState(); }
    if (vpick && hasIO) {
      new IntersectionObserver(function (entries) { var en = entries[entries.length - 1]; vpickOn = en.isIntersecting || en.boundingClientRect.top < 0; barCalc(); }, { threshold: 0 }).observe(vpick);
    }
    /* desktop only: the buy box is already on the first screen, so the floating bar waits until its own Add to cart has scrolled out of view above */
    var buyEl = d.querySelector('.revive-blocks .buy-buttons-block') || d.querySelector('.revive-blocks .product-form-buttons');
    if (buyEl && hasIO) {
      new IntersectionObserver(function (entries) { var en = entries[entries.length - 1]; buyPast = !en.isIntersecting && en.boundingClientRect.bottom < 0; barCalc(); }, { threshold: 0 }).observe(buyEl);
    }
    if (deskMq.addEventListener) deskMq.addEventListener('change', barCalc);
    stickyState();
  }

  /* 3. "Save R..." chip: worked out from the live sale and regular price the theme already shows, so it follows every variant change. */
  function num(t) { var m = (t || '').replace(/[^0-9.,]/g, '').replace(/,/g, ''); var n = parseFloat(m); return isNaN(n) ? 0 : n; }
  function fmt(n) { return 'R ' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  var scope = d.querySelector('[data-revive-blocks]');
  var saveEl = null;
  function updateSave() {
    if (!scope) return;
    var pp = scope.querySelector('product-price');
    if (!pp) return;
    var sale = pp.querySelector('.price-item--sale'), reg = pp.querySelector('.price-item--regular, .compare-at-price');
    var diff = sale && reg ? num(reg.textContent) - num(sale.textContent) : 0;
    var seal = d.querySelector('[data-revive-seal]'); if (seal && seal.parentNode !== pp) pp.appendChild(seal);
    if (!saveEl) { saveEl = d.createElement('span'); saveEl.className = 'revive-save'; saveEl.hidden = true; pp.appendChild(saveEl); }
    else if (saveEl.parentNode !== pp) { pp.appendChild(saveEl); }
    /* only touch the DOM when something changed, so the observer below never loops */
    var txt = diff > 0 ? 'You save ' + fmt(diff) : '';
    if (saveEl.textContent !== txt) saveEl.textContent = txt;
    if (saveEl.hidden !== (diff <= 0)) saveEl.hidden = diff <= 0;
  }
  function syncPick() {
    var pickEl = d.querySelector('[data-revive-pick]'), priceEl = d.querySelector('[data-revive-pick-price]');
    if (!pickEl || !priceEl || !scope) return;
    var vals = [].map.call(scope.querySelectorAll('variant-picker input:checked, variant-picker select'), function (i) { return i.value; });
    pickEl.textContent = vals.join(' / ');
    var s = scope.querySelector('product-price .price-item--sale') || scope.querySelector('product-price .price');
    priceEl.textContent = s ? s.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function refresh() { updateSave(); syncPick(); }
  if (scope) {
    refresh();
    if ('MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () { if (pending) return; pending = setTimeout(function () { pending = null; refresh(); }, 60); }).observe(scope, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });
    }
    scope.addEventListener('change', function () { setTimeout(refresh, 30); });
  }

  /* 4. final Add to cart: press the real Add to cart in the buy box, so variant, quantity and price are the chosen ones */
  d.addEventListener('click', function (ev) {
    var fin = ev.target.closest && ev.target.closest('[data-revive-final-add]');
    if (fin) {
      /* the closing Buy now takes the visitor up to the size selects and lights them up; it never adds to cart by itself */
      ev.preventDefault();
      var vp = d.querySelector('.revive-blocks variant-picker');
      if (vp) {
        var top = vp.getBoundingClientRect().top + window.pageYOffset - 110;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        vp.classList.add('revive-flash');
        setTimeout(function () { vp.classList.remove('revive-flash'); }, 1800);
      }
      return;
    }    /* 5. click to load the factory video */
    var play = ev.target.closest && ev.target.closest('[data-revive-play]');
    if (play) {
      var host = play.closest('[data-revive-video]');
      var id = host && host.getAttribute('data-revive-video');
      if (!id) return;
      var wrap = d.createElement('div'); wrap.className = 'revive-video__frame';
      var f = d.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'See how your mattress is made';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      wrap.appendChild(f);
      host.innerHTML = '';
      host.appendChild(wrap);
      return;
    }
    /* 6. smooth scroll to the buy box */
    var a = ev.target.closest && ev.target.closest('a[href="#revive-buy"]');
    if (a) {
      var tg = d.getElementById('revive-buy');
      if (!tg) return;
      ev.preventDefault();
      tg.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  });
})();
